export interface IMatrixFile {
    id: number;
    filename: string;
    modified_date: string;
    year?: number;
    month?: number;
}

export interface IMatrixState {
    status: number | null;
    total: number | null;
    done: number | null;
    message?: string;
}

export const matrixInitialState: IMatrixState = {
    status: null,
    total: null,
    done: null,
};

export interface IMatrixTaskCreate {
    files: File[];
    // name: string;
    // description?: string;
    // sources: string[];
    // deep: number;
}

